export function isArrayWithItems<T>(value: T[] | null | undefined): value is T[] {
  return Boolean(value && value.length);
}
